<template>
  <div class="general-page">
    <h1>Set New Password</h1>

    <p>Please pick a new password below.</p>
    <div class="qform2022 full">
      <p
        v-if="first(errors) || errors.recaptcha_response"
        class="notice error live"
      >
        <span class="icon-attention redicon" />
        {{ first(errors) }}
      </p>

      <form @submit.prevent="post">
        <div class="generic-inputs">
          <label>New password*</label>
          <input
            v-model="password"
            :type="[show_password ? 'text' : 'password']"
            placeholder="Password"
            autocomplete="new-password"
          >
        </div>

        <div class="generic-inputs">
          <div
            class="terms-container checkbox terms-checkbox"
            style="margin-top: 0px"
            :class="{ 'active': show_password }"
            @click="toggleShowPassword"
          >
            <div class="checkbox" />
            <input
              type="hidden"
              name="show_password"
              value=""
            >
            <p>Show password</p>
          </div>
        </div>

        <div
          v-if="loading"
          class="twobuttons"
        >
          <img
            src="/assets/images/loading.gif"
            style="width:200px;"
          >
        </div>
        <div
          v-else
          class="twobuttons"
        >
          <button class="button">
            Set Password
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import axios from "../../axios";
import authComposable from "./AuthComposable";
import { useRoute } from 'vue-router';

export default {
    setup() {
        const route = useRoute();
        const loading = ref(false);
        const errors = ref([]);
        const show_password = ref(false);
        const password = ref(null);
        const { first } = authComposable();

        const toggleShowPassword = () => {
            show_password.value = !show_password.value;
        };

        const post = () => {
            loading.value = true;
            errors.value = [];

            axios({
                method: 'post',
                url: `/auth/forgotten-password/set-password/${route.params.code}`,
                data: {
                    password: password.value,
                }
            }).then(response => {
                if (!response.data.success) {
                    errors.value = response.data.errors;
                } else if (response.data.redirect) {
                    window.location = response.data.redirect;
                }
            }).catch(() => {
                errors.value = { general: ['Something went wrong; please try again later.'] };
            }).finally(() => {
                loading.value = false;
            });
        };

        return {
            loading,
            errors,
            show_password,
            password,
            post,
            toggleShowPassword,
            first,
        };
    },
};
</script>
